export type FormState = 'entry' | 'processing' | 'redirecting' | 'error'

export type RefToken = string

export enum FormType {
  DONATION = 'donation',
  MONTHLY = 'monthly',
  COMPANY = 'companyDonation',
  GIFTCERT = 'giftcert',
}
